export default __webpack_public_path__ + "justhatched-devices_mobile@2x.d4e0199e.png";